import { Component, Input, ViewEncapsulation } from '@angular/core';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { InvoiceItemModel } from 'app/models/invoice-item.model';
import { InvoiceModel } from 'app/models/invoice.model';

@Component({
    selector: 'app-invoice-detail',
    templateUrl: './invoice-detail.component.html',
    styleUrls: ['./invoice-detail.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InvoiceDetailComponent {

  public beginning_items: Array<InvoiceItemModel>;
  public beginning_total: number;

  public utility_items: Array<InvoiceItemModel>;
  public utility_total: number;

  public fee_items: Array<InvoiceItemModel>;
  public fee_total: number;

  public payment_items: Array<InvoiceItemModel>;
  public payment_total: number;

  public default_items: Array<InvoiceItemModel>;
  public default_total: number;

  public additional_items: Array<InvoiceItemModel>;
  public additional_total: number;

  public default_customer_array: any;
  public invoice_model: InvoiceModel;
  public faExclamationCircle = faExclamationCircle;

  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('invoice') public set update_items(data: InvoiceModel)
  {
    this.beginning_items = data.items.filter(f => f.section === 'beginning');
    this.beginning_total = this.beginning_items.reduce((sum, current) => sum + current.amount, 0);

    this.utility_items = data.items.filter(f=>f.expected_bill != null && !f.section);
    this.utility_total = this.utility_items.reduce((sum, current) => sum + current.amount, 0);
    this.fee_items = data.items.filter(f=>f.expected_bill == null && !f.section);
    this.fee_total = this.fee_items.reduce((sum, current) => sum + current.amount, 0);

    this.payment_items = data.items.filter(f => f.section === 'payment');
    this.payment_total = this.payment_items.reduce((sum, current) => sum + current.amount, 0);

    this.default_items = data.items.filter(f => f.section === 'default');
    this.default_total = this.default_items.reduce((sum, current) => sum + current.amount, 0);

    this.additional_items = data.items.filter(f => f.section === 'additional');
    this.additional_total = this.additional_items.reduce((sum, current) => sum + current.amount, 0);

    this.default_customer_array = this.fee_items.filter(res => res.invoice_item_type.resident_class === 'default');
    this.invoice_model = data;
  }

  constructor() { }

}
